import styled from "@emotion/styled";
import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import BlueprintIconPng from "../../assets/icons/steps/blueprint.png";
import UsersIconPng from "../../assets/icons/steps/users.png";
import WithdralIconPng from "../../assets/icons/steps/withdral.png";
import bgImage from "../../assets/images/bg-chart.svg";
import CardGroup from "../shared/CardGroup";
import Container from "../shared/Container";

const TitleHighlight = styled("span")(() => ({
  color: "#00DB97",
}));

const BGImage = styled("img")(() => ({
  position: "absolute",
  left: 0,
  top: -150,
  width: "100%",
}));

const Steps: FC = () => {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ position: "relative" }}>
      <BGImage src={bgImage} alt="" />
      <Container sx={{ position: "relative", pt: { xs: 4, md: 6 } }}>
        <Stack spacing={{ xs: 4, md: 8 }} alignItems="center">
          <Stack spacing={2} maxWidth={800} sx={{ mx: "auto" }}>
            <Typography
              fontFamily="Epilogue"
              fontSize={40}
              fontWeight={700}
              lineHeight={1.2}
              textAlign="center"
            >
              {t("how_to_operate_title_1")}{" "}
              <TitleHighlight>{t("how_to_operate_title_2")}</TitleHighlight>
            </Typography>
            <Typography fontSize={16} lineHeight={1.5} textAlign="center">
              {t("how_to_operate_description")}
            </Typography>
          </Stack>
          <Box>
            <CardGroup
              showArrowIcon
              items={[
                {
                  icon: BlueprintIconPng,
                  title: t("sign_up"),
                  text: t("sign_up_description"),
                },
                {
                  icon: UsersIconPng,
                  title: t("practice"),
                  text: t("practice_description"),
                },
                {
                  icon: WithdralIconPng,
                  title: t("make_a_deposit_and_start_trading"),
                  text: t("make_a_deposit_and_start_trading_description"),
                },
              ]}
            />
          </Box>
          <Button
            component={RouterLink}
            to="/register"
            variant="contained"
            size={isMobile ? "medium" : "large"}
          >
            {t("practice_with_a_demo_account")}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default Steps;
